// НАРЕЗКА КУСКОВ ЗАПИСИ — «РЕЖИМ 3» (Г-2 `3e619875cbb8815b9b9cd05ae4eb2279`, проверен на айфоне Кирилла).
//
// Один `MediaRecorder` на всю запись. Его куски со второго — НЕ самостоятельные файлы: на iOS это
// `moof,mdat` без заголовка, в Chrome — кластеры WebM без шапки. Чтобы кусок ушёл на сервер сам по
// себе (вызов `chunk`, Г-3), к нему приклеиваются байты ПЕРВОГО куска до его первого фрагмента:
//   MP4  — всё до первого бокса `moof` (`ftyp`+`moov`, на iPhone 652 Б);
//   WebM — всё до первого `Cluster` (EBML-шапка, `Segment`, `Tracks`).
// Тело куска начинается со своего первого фрагмента; байты до него — хвост фрагмента предыдущего
// куска, в черновик этого куска они не идут (черновик всё равно заменит финал, `s988.d5`).
//
// ⚠️ MP4 работает только при `default-base-is-moof` в `tfhd` (смещения данных от `moof`, а не от
// начала файла) — так пишет Safari, замер Г-2. Финал — склейка ВСЕХ кусков, то есть целый файл, и
// этой оговорки не касается.
//
// Чистые функции над байтами: без браузера, проверяются на настоящих файлах.

const MOOF = [0x6d, 0x6f, 0x6f, 0x66]; // 'moof'
const CLUSTER = [0x1f, 0x43, 0xb6, 0x75]; // EBML ID кластера WebM

function indexOf(u8, pat, from = 0) {
  outer: for (let i = from; i + pat.length <= u8.length; i++) {
    for (let k = 0; k < pat.length; k++) if (u8[i + k] !== pat[k]) continue outer;
    return i;
  }
  return -1;
}

/** Контейнер по типу записи рекордера: `mp4` | `webm` | `null` (склейка не умеет — кусков не шлём). */
export function containerOf(mimeType) {
  const t = String(mimeType || '').toLowerCase();
  if (t.includes('mp4') || t.includes('m4a') || t.includes('aac')) return 'mp4';
  if (t.includes('webm')) return 'webm';
  return null;
}

/**
 * Начало первого фрагмента в байтах куска: MP4 — смещение бокса `moof` (на 4 байта раньше имени,
 * там его размер), WebM — смещение ID `Cluster`. Нет — `-1`.
 */
export function firstFragment(u8, container) {
  if (container === 'mp4') {
    const at = indexOf(u8, MOOF, 4);
    return at < 0 ? -1 : at - 4;
  }
  if (container === 'webm') return indexOf(u8, CLUSTER);
  return -1;
}

/** Заголовок из первого куска: байты до первого фрагмента. Нет фрагмента или он в самом начале — `null`. */
export function initSegment(firstChunk, container) {
  const at = firstFragment(firstChunk, container);
  return at > 0 ? firstChunk.subarray(0, at) : null;
}

/**
 * Самостоятельный файл из куска `k` (с нуля). Первый кусок уже файл — отдаётся как есть.
 * Остальные — заголовок + тело с первого фрагмента. Склеить нельзя — `null` (кусок не шлём).
 * @param {Uint8Array} chunk
 * @param {number} k
 * @param {Uint8Array|null} init
 * @param {'mp4'|'webm'|null} container
 * @returns {Uint8Array|null}
 */
export function standalone(chunk, k, init, container) {
  if (!chunk || !chunk.length) return null;
  if (k === 0) return chunk;
  if (!init) return null;
  const at = firstFragment(chunk, container);
  if (at < 0) return null;
  const out = new Uint8Array(init.length + chunk.length - at);
  out.set(init, 0);
  out.set(chunk.subarray(at), init.length);
  return out;
}
